import { ReactNode } from 'react';
import ManagePermissionGroupsStateContext
  from '@/dataroom/application/permissionGroups/manage/ManagePermissionGroupsStateContext';

interface IProps {
  children: ReactNode,
}

const ManagePermissionGroupsLayout = ({ children }: IProps) => (
  <ManagePermissionGroupsStateContext>
    { children }
  </ManagePermissionGroupsStateContext>
);

export default ManagePermissionGroupsLayout;
